import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiSwitchOverrides = {
  defaultProps?: ComponentsProps["MuiSwitch"];
  styleOverrides?: ComponentsOverrides<Theme>["MuiSwitch"];
  variants?: ComponentsVariants["MuiSwitch"];
};

function getMuiSwitchOverride(): MuiSwitchOverrides {
  return {
    styleOverrides: {
      switchBase: {
        color: "#ccc",
      },
      colorPrimary: {
        "&.Mui-checked": {
          color: "#fff",
        },
      },
      track: {
        height: "14px",
        width: "32px",
        opacity: 1,
        backgroundColor: "#F4F4F5",
        marginLeft: "-2px",

        ".Mui-checked.Mui-checked + &": {
          opacity: 1,
          backgroundColor: "#2B244C !important",
          marginLeft: "-2px",
        },
      },
      thumb: {
        height: "12px",
        width: "12px",
        marginTop: "4px",
      },
    },
  };
}

export default getMuiSwitchOverride;
